import Http from "@/commons/Http";
import Utils from "@/utils/Utils";
import PDFBusiness from "@/business/PDFBusiness";
import WordBusiness from "@/business/WordBusiness";

const path = 'api/letter';

export default {

    async getAll(){
        return Http.get(`${path}`);
    },

    async save(dto, id = ''){
        return Http.post(`${path}/${id}`, dto);
    },

    async delete(id = ''){
        return Http.delete(`${path}/${id}`);
    },

    async getById(id){
        return Http.get(`${path}/${id}`);
    },

    async audit(sort, direction, page, size){
        const filters = {entity: "Letter"};
        return Http.post(`${path}/audit?sort=${sort || 'l.created'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, {filters});
    },

    async pagination(sort, direction, page, size, filters = {}){
        return Http.post(`${path}/pagination?sort=${sort || 'l.name'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, filters);
    },

    async searchByName(name) {
        if(Utils.isEmptyNullOrUndefined(name)) {
            return this.getAll();
        }
        return Http.get(`${path}/s/${name}/10`);
    },

    async getHtmlLetter(protocolId){
        return Http.get(`${path}/html/generate/protocol/${protocolId}`);
    },

    async printLetterFromHtmlPdf(protocolId, htmlBudget){
        const url = `${path}/pdf/generate/protocol/${protocolId}`;
        return await PDFBusiness.showPdf(url, htmlBudget);
    },

    async printLetterFromHtmlWord(protocolId, htmlBudget){
        const url = `${path}/word/generate/protocol/${protocolId}`;
        return await WordBusiness.showWord(url, htmlBudget);
    },

    async getErrorsValidation(id){
        return Http.get(`${path}/validation/protocol/${id}`);
    },
}
